import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InlinePrompt from "@Shared/components/general/inline-prompt";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConsentTable",
  components: {
    InlinePrompt
  },
  props: {
    consentRequests: {
      type: Array,
      default: () => []
    },
    isBrokerage: {
      type: Boolean
    }
  },
  data() {
    return {
      columns: ["message", "document", "actions"]
    };
  },
  computed: {
    isEmptyData() {
      return isEmpty(this.consentRequests);
    },
    options() {
      return {
        filterable: false,
        showChildRowToggler: false,
        headings: {
          enabled: `${this.$t("global.words.enabled")}?`,
          message: this.$t("settings.disclaimers.consentMessageTitle"),
          document: this.$t("settings.disclaimers.linkedDocument"),
          actions: "nodisplay"
        },
        sortable: [],
        tabbable: false,
        columnsClasses: {
          enabled: "text-center",
          message: "w-75"
        },
        skin: "table table-hover",
        perPage: 999999
      };
    }
  },
  mounted() {
    if (!this.isBrokerage) this.columns.unshift("enabled");
  },
  methods: {
    showPreviewer({
      fileName,
      documentId
    }) {
      this.$emit("show-document-previewer", {
        fileName,
        documentId
      });
    },
    handleRemove(row) {
      this.$emit("delete-disclaimer", {
        disclaimer: row
      });
    },
    toggleConsentEnabled(row) {
      this.$emit("update-disclaimer", _objectSpread(_objectSpread({}, row), {}, {
        enabled: !row.enabled
      }));
    }
  }
});